export default [
  {
    path: "/availability-spklu",
    name: "available-spklu",
    component: () => import("../../views/available_spklu/available_spklu.vue"),
    // meta: {
    //   title: "History Charger Box test",
    //   activeMenu: "History Charger Box",
    //   breadcrumb: [
    //     {
    //       text: "History Charger Box",
    //       disabled: true,
    //     },
    //   ],
    // },
  },
];
